import { useState, useEffect, useCallback } from 'react';

export interface HashRoute {
    path: string;
    chunks: string[];
}

export function useHashRouter() {
    const getPath = () => window.location.hash.replace('#', '') || 'login';

    const [path, setPath] = useState<string>(getPath);

    useEffect(() => {
        const handlePopState = () => {
            setPath(getPath());
        };

        window.addEventListener('popstate', handlePopState);

        // Ensure we start at the login screen if no hash
        if (!window.location.hash || window.location.hash === '#') {
            window.history.pushState({}, 'Family Tree: Login', '#login');
            setPath('login');
        }

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    const navigate = useCallback((title: string, newPath: string) => {
        console.log('Navigate ' + newPath);
        window.history.pushState({}, title, '#' + newPath);
        setPath(newPath);
    }, []);

    const chunks = path.split('/').filter(Boolean);

    return {
        path,
        chunks,
        navigate,
    };
}
